import { t } from "../lib/i18n";
import React, { useState, useEffect } from 'react';
import api from '../api';
import { dispatchDocumentChangeEvent } from '../eventSystem';

interface Document {
  id: string;
  file_name: string;
  description?: string;
}

interface EditDocumentModalProps {
  document: Document | null;
  onClose: () => void;
}

const EditDocumentModal: React.FC<EditDocumentModalProps> = ({ document, onClose }) => {
  const [fileName, setFileName] = useState('');
  const [description, setDescription] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (document) {
      setFileName(document.file_name);
      setDescription(document.description || '');
    }
  }, [document]);

  const handleSave = async () => {
    if (!document) return;

    try {
      await api.put(`/documents/${document.id}`, {
        file_name: fileName,
        description: description,
      });
      setMessage('Document updated successfully!');
      dispatchDocumentChangeEvent();
      onClose();
    } catch (error: any) {
      console.error('Error updating document:', error);
      setMessage(error.response?.data?.detail || 'Failed to update document.');
    }
  };

  if (!document) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-bg-secondary p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold text-text-primary mb-4">{t("editDocumentModal.k1")}</h2>
        {message && <p className="text-danger mb-4">{message}</p>}
        <div className="mb-4">
          <label htmlFor="fileName" className="block text-text-secondary text-sm font-bold mb-2">{t("editDocumentModal.k2")}</label>
          <input
            type="text"
            id="fileName"
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-text-primary leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="description" className="block text-text-secondary text-sm font-bold mb-2">{t("editDocumentModal.k3")}</label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-text-primary leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div className="flex justify-end gap-4">
          <button onClick={onClose} className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600">
            {t("editDocumentModal.k4")} </button>
          <button onClick={handleSave} className="bg-primary text-white px-4 py-2 rounded hover:bg-primary-dark">
            {t("editDocumentModal.k5")} </button>
        </div>
      </div>
    </div>
  );
};

export default EditDocumentModal;
